import ng from 'angular';
import {
    SystemHelperService,
    ValidateNotEmpty,
    ValidateRegularExpression,
} from '@/services';
import { MoleculeFormEditController } from '@/atomic-components/molecules';

export class TemplateAccountActivationBasicDataController {
    public static $inject: string[] = [
        'systemHelper',
        '$translate',
        '$timeout'
    ]

    public editForm: MoleculeFormEditController;
    public city: string;
    public country: string;
    public email: string;
    public formIsValid: boolean;
    public name: string;
    public panelRightSettings = { editPanelButton: true }
    public password: string;
    public repeatPassword: string;
    public phone: string;
    public saveCallback: () => Promise<void>;
    public street: string;
    public zipCode: string;
    public requireVatId: boolean;
    public vatIdIsValid: boolean;
    public vatId: string;
    public noVatIdChecked = false;

    constructor(
        private systemHelper: SystemHelperService,
        protected $translate: ng.translate.ITranslateService,
        private $timeout: ng.ITimeoutService
    ) {}

    public get countryName(): string {
        return this.systemHelper.getReadableCountry(this.country);
    }

    public vatIdValidationInstructions: any[] = [
        {
            settings: null,
            validator: new ValidateNotEmpty(this.$translate)
        },
        {
            settings: null,
            validator: new ValidateRegularExpression(this.$translate, '^[A-Za-z]{2}[^ ]+$', 'ig', false, true)
        }
    ];

    public revalidate = (): void => {
        void this.$timeout(
            () => {
                this.editForm.validateAll();
            }
        );
    };

    public noVatClicked = () => {
        this.vatId = '';
    }
}

export class TemplateAccountActivationBasicDataComponent implements ng.IComponentOptions {
    public bindings = {
        city: '=',
        country: '<',
        email: '<',
        formIsValid: '=',
        name: '<',
        password: '=',
        phone: '=',
        requireVatId: '<',
        vatId: '=',
        noVatIdChecked: '=',
        vatIdIsValid: '=',
        saveCallback: '<',
        street: '=',
        token: '<',
        zipCode: '=',
    };
    public template = require('./basic-data.html');
    public controller = TemplateAccountActivationBasicDataController;
}
